import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CountriesListModel } from 'src/app/models/countries-list.model';
import { UserDetails } from 'src/app/models/user-details.model';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { VerificationContractService } from 'src/app/services/Auth/verification-contract.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';

@Component({
  selector: 'ipm-mobile-verify',
  templateUrl: './mobile-verify.component.html',
  styleUrls: ['./mobile-verify.component.scss']
})
export class MobileVerifyComponent implements OnInit {
  @Input({required : true}) form!: FormGroup<any>;
  @Input({required : false}) isInitialBoolean: boolean = false;
  countryListArray: Array<CountriesListModel> = [];
  @Input({required : false}) currentUserData: UserDetails;
  @Input({required : false}) isShowActionButton: boolean = true;
  /** 'whatsapp' = MSG91/WhatsApp for buyers, 'surepass' = SurePass SMS KYC for producers */
  @Input({required : false}) verificationMethod: 'whatsapp' | 'surepass' = 'whatsapp';
  @ViewChild('otpTemplate', {static :  false}) otpTemplate : TemplateRef<any>;
  errorMessage : string = "";
  OTPInputData: any = {}; 
  @Output() onChangeDataSttaus: EventEmitter<any> = new EventEmitter();
  constructor( public commonService: CommonService,
    public formService: FormsService,
    private authService: AuthService,
    private verificationContract: VerificationContractService,
    private ga4TrackingService: Ga4trackingService,
    public userService: UserService) {};

  ngOnInit(): void {
    this.getCountryList();
    if (this.isShowActionButton) {
      this.updateMobileNumberData();
    } else {
      this.form.controls['countryCodeNumber'].setValue( this.setDropDownValue("countryDialCode", '+91'));
      this.form.controls['countryCodeNumber'].disable();
      if (this.isInitialBoolean && this.currentUserData?.mobile?.number) {
        this.form.controls['mobileNumber'].disable();
      }
    }
  }

  /**
   * set Country List  array
   */
  getCountryList() {
    this.countryListArray = this.commonService.getCountriesList();
  }

  /**
   * update mobile number data
   */
  updateMobileNumberData() {
    if (this.currentUserData?.mobile) {
      let ISDCode = this.currentUserData?.mobile?.isd;
      this.form.controls['countryCodeNumber'].setValue( this.setDropDownValue("countryDialCode", ISDCode ? ISDCode : '+91'));
      if (this.currentUserData?.mobile?.isVerified) {
        this.form.controls['mobileNumber'].disable();
        this.form.controls['countryCodeNumber'].disable();
      }
      if (!this.currentUserData.detail?.store?.general?.phone) {
        this.form.controls['mobileNumber'].setValue(this.currentUserData?.mobile?.number);
      }
    } else {
      this.form.controls['countryCodeNumber'].setValue( this.setDropDownValue("countryDialCode", '+91'));
      this.form.controls['countryCodeNumber'].disable();
    }
  }

  /**
   * Send Otp function 
   */
  sendOtp(isResend: boolean = false) {
    this.errorMessage = '';
    let mobileNumber = this.form.controls['mobileNumber'].value;
    let countryCodeNumber = this.form.controls['countryCodeNumber'].value;
    if (mobileNumber) {
      if (this.verificationMethod === 'surepass') {
        this.sendOtpViaSurepass(mobileNumber, countryCodeNumber, isResend);
      } else {
        this.sendOtpViaWhatsapp(mobileNumber, countryCodeNumber, isResend);
      }
    }
  }

  /**
   * SurePass SMS KYC flow — used by producers
   * Calls /idvalidation/mobile/generate-otp
   */
  private sendOtpViaSurepass(mobileNumber: string, countryCodeNumber: any, isResend: boolean) {
    this.userService.generateMobileNumberOtp(mobileNumber).subscribe((response: any) => {
      let eventName = "verify_mobile_initiated";
      this.ga4TrackingService.sendEvent(eventName, {
        event_category: 'mobile_verification',
        event_label: isResend ? 'resend_otp' : 'initial_otp_send',
        moblienumber : '+' + (countryCodeNumber?.dialCode?.replace(/^\+/, '') || '') + mobileNumber
      });
      let mobileNumberObj = {
        isd: countryCodeNumber?.dialCode,
        number: response?.data?.mobileNumber,
      };
      if (isResend) {
        this.OTPInputData.clientId = response?.data?.clientId;
      } else {
        this.openOtpModel(mobileNumberObj, response?.data?.clientId, 'mobile-verify');
      }
    }, (error: any) => {
      const message = error?.error?.details || error?.error?.error || error?.error?.message || 'Failed to send OTP. Please try again.';
      if (isResend) {
        this.errorMessage = message;
      } else {
        this.commonService.showToastErrorMessage(message);
      }
    });
  }

  /**
   * WhatsApp/MSG91 flow — used by buyers
   * Calls /auth/send-mobile-verification
   */
  private sendOtpViaWhatsapp(mobileNumber: string, countryCodeNumber: any, isResend: boolean) {
    this.authService.sendMobileVerification({
      isd: countryCodeNumber?.dialCode,
      number: (mobileNumber || '').toString().replace(/\D/g, '')
    }).subscribe((response: any) => {
      let eventName = "verify_mobile_initiated";
      this.ga4TrackingService.sendEvent(eventName, {
        event_category: 'mobile_verification',
        event_label: isResend ? 'resend_otp' : 'initial_otp_send',
        moblienumber : '+' + (countryCodeNumber?.dialCode?.replace(/^\+/, '') || '') + mobileNumber
      });
      let mobileNumberObj = {
        isd: response?.data?.mobile?.isd || countryCodeNumber?.dialCode,
        number: response?.data?.mobile?.number || response?.data?.mobileNumber || mobileNumber,
      };
      if (isResend) {
        this.OTPInputData.mobileNumber = mobileNumberObj;
      } else {
        this.openOtpModel(mobileNumberObj, '', 'mobile-verify');
      }
    }, (error: any) => {
      const message = this.verificationContract.extractErrorMessage(error);
      if (isResend) {
        this.errorMessage = message;
      } else {
        this.commonService.showToastErrorMessage(message);
      }
    });
  }


    /**
   * open otp pop function
   * @param sendData
   */
  openOtpModel(mobileNumber: any, clientId: string, callingFrom: string) {
    this.errorMessage = '';
    this.OTPInputData = {
      mobileNumber: mobileNumber,
      type: 'mobile-number',
      callingFrom: callingFrom,
      clientId: clientId,
      channel: this.verificationMethod === 'surepass' ? 'sms' : 'whatsapp'
    };
    let className = this.commonService.getClassName('ipm-otp-model');
    this.commonService.openModel(this.otpTemplate, this.OTPInputData, className, true);
    if (!this.commonService.isMobileDisableClick) {
      if (this.commonService.modelRef) {
        this.commonService.modelRef.afterClosed().subscribe((res) => {
          this.updateDataClosePopup(res);
        });
      }
    } else {
      if (this.commonService.bottomRef) {
        this.commonService.bottomRef.afterDismissed().subscribe((res) => {
          this.updateDataClosePopup(res);
        });
      }
    }
  }


  updateDataClosePopup(res: any) {
    if (!res && !this.isInitialBoolean) {
      this.closePopOver("event");
    }
  }


  /**
   * set Data From Mobile Data
   * @param type 
   * @param value 
   * @returns 
   */
  setDropDownValue(type: string, value: any) {
    let finalObject: any = ""
    if (type === "countryDialCode") {
      let found = this.countryListArray.find( (item: CountriesListModel) =>  item.dialCode === value);
      if (found) {
        finalObject = found;
      }
    }
    return finalObject;
  }

  /**
   * get Drop Down data from Counter Obj
   * @param type 
   * @param value 
   * @returns 
   */
  getDropDownValue(type: string, value: any) {
    let finalValue = "";
    if (type === "countryDialCode") {
      finalValue =  value?.dialCode;
    }
    return finalValue;
  }

  
/**
 *  Enable the Mobile Number Edit
 */
  isEnableEdit() {
    this.form.controls['mobileNumber'].enable();
    // WhatsApp/MSG91 supports international numbers — unlock country code for buyers
    if (this.verificationMethod === 'whatsapp') {
      this.form.controls['countryCodeNumber'].enable();
    }
  }

  /**
   * 
   * @param event resend otp event
   */
  resendOpt(event: boolean) {
    if (event) {
      this.errorMessage = '';
      this.sendOtp( true);
    }
  }

  /**
   * Update Function for Mobile Number
   */
   updateMobileNumber() {
    let mobNumber = this.form.controls['mobileNumber'].value;
    let countryCode = this.form.controls['countryCodeNumber'].value;
    let exitISDCode = this.currentUserData?.mobile?.isd ? this.currentUserData?.mobile?.isd : '+91';
    if (mobNumber) {
      if (Object.keys(countryCode).length > 0) {
        if (mobNumber !== this.currentUserData.mobile.number || countryCode['dialCode'] !== exitISDCode) {
          this.sendOtp();
        } else {
          this.commonService.showToastErrorMessage('This Mobile number is already verified.');
        }
      } else {
        this.commonService.showToastErrorMessage('Please select country code.');
      }
    } else {
      this.commonService.showToastErrorMessage('Please enter your mobile no.');
    }
  }

  /**
   * Close popover function
   * @param event 
   */
   closePopOver(event: any) {
    if (event) {
      let mobNumber = this.form.controls['mobileNumber'].value;
      let countryCode = this.form.controls['countryCodeNumber'].value;
      let exitISDCode = this.currentUserData?.mobile?.isd ? this.currentUserData?.mobile?.isd : '+91';
      if (!mobNumber || Object.keys(countryCode).length === 0) {
        this.form.controls['mobileNumber'].setValue(this.currentUserData?.mobile?.number);
        this.form.controls['countryCodeNumber'].setValue(this.getDropDownValue('countryDialCode', exitISDCode));
        this.form.controls['countryCodeNumber'].disable();
      } else if (mobNumber !== this.currentUserData?.mobile?.number || countryCode['dialCode'] !== exitISDCode) {
        this.form.controls['mobileNumber'].setValue(this.currentUserData?.mobile?.number);
        this.form.controls['countryCodeNumber'].setValue(this.setDropDownValue('countryDialCode', exitISDCode));
        this.form.controls['countryCodeNumber'].disable();
      }
      this.form.controls['mobileNumber'].disable();
      this.form.controls['countryCodeNumber'].disable();
    }
  }

  /**
   * Verify OTP for mobile number
   * @param otpData OTP data
   */
  verifyOtp(otpData: any) {
    this.errorMessage = "";
    if (otpData && Object.keys(otpData).length > 0) {
      if (this.verificationMethod === 'surepass') {
        this.verifyOtpViaSurepass(otpData);
      } else {
        this.verifyOtpViaWhatsapp(otpData);
      }
    }
  }

  /**
   * SurePass verification — matches production flow exactly
   * Uses clientId from OTPInputData, calls /idvalidation/mobile/verify-otp
   */
  private verifyOtpViaSurepass(otpData: any) {
    this.userService.verifyMobileOTP(otpData.clientId, otpData?.otp).subscribe((response: any) => {
      if (response) {
        this.commonService.closePopUp();
        this.currentUserData.mobile = response?.mobile;
        this.currentUserData.mobile['number'] = response?.mobile?.mobileNumber;
        this.currentUserData.mobile['isVerified'] = response?.mobile?.verified;
        this.afterMobileVerificationSuccess();
      }
    }, (error: any) => {
        this.errorMessage = error?.error?.details || error?.error?.error || 'Something went wrong, please try again.';
    });
  }

  /**
   * WhatsApp/MSG91 verification — for buyers
   * Calls /auth/verify-mobile
   */
  private verifyOtpViaWhatsapp(otpData: any) {
    const otpCode = (otpData?.code || otpData?.otp || '').replace(/\D/g, '');
    this.authService.verifyMobileVerification(otpCode).subscribe((response: any) => {
      if (response) {
        this.authService.getCurrentUserDetails().subscribe((userDetails: any) => {
          if (userDetails && Object.keys(userDetails).length > 0) {
            this.currentUserData = userDetails;
          } else {
            this.updateMobileDataFromWhatsappResponse(response);
          }
          this.commonService.closePopUp();
          this.afterMobileVerificationSuccess();
        }, () => {
          this.updateMobileDataFromWhatsappResponse(response);
          this.commonService.closePopUp();
          this.afterMobileVerificationSuccess();
        });
      }
    }, (error: any) => {
        this.errorMessage = this.verificationContract.extractErrorMessage(error);
    });
  }

  /**
   * Helper to map WhatsApp/MSG91 response to currentUserData.mobile
   */
  private updateMobileDataFromWhatsappResponse(response: any): void {
    const responseMobile = response?.data?.mobile || response?.mobile || {};
    const selectedCountry = this.form.controls['countryCodeNumber'].value;
    if (!this.currentUserData.mobile) {
      this.currentUserData.mobile = {
        isd: '',
        number: '',
        isVerified: false
      };
    }
    this.currentUserData.mobile = {
      ...this.currentUserData.mobile,
      isd: responseMobile?.isd || selectedCountry?.dialCode || this.currentUserData.mobile?.isd || '+91',
      number:
        responseMobile?.number ||
        responseMobile?.mobileNumber ||
        this.form.controls['mobileNumber'].value ||
        this.currentUserData.mobile?.number,
      isVerified:
        responseMobile?.isVerified ??
        responseMobile?.verified ??
        true
    };
  }

  /**
   * Common success handler after mobile verification
   */
  private afterMobileVerificationSuccess(): void {
    if (this.isInitialBoolean && this.currentUserData?.mobile?.number) {
      this.form.controls['mobileNumber'].disable();
    }
    this.onChangeDataSttaus.emit(this.currentUserData);
    this.authService.currentUserDetails.next(this.currentUserData);
    this.OTPInputData = {};
    this.commonService.showToastSuccess('OTP verified successfully.');
    let eventName = "verify_mobile_completed";
    this.ga4TrackingService.sendEvent(eventName, {
      event_category: 'mobile_verification',
      event_label: 'otp_verified_successfully',
      moblienumber : '+' + (this.form.controls['countryCodeNumber'].value?.dialCode?.replace(/^\+/, '') || '') + this.form.controls['mobileNumber'].value
    });
  }

}
